import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { Chart, ChartEditorOptions, ChartJsDataModel } from '../../domain/chart/ChartDomains';
import { TokenVariable } from '@trlogic/ui-pack';

export type ChartActions =
  | 'CHANGE_CHART'
  | 'CHANGE_CHART_EDITOR_OPTIONS'
  | 'CHANGE_IS_UPDATE'
  | 'CLEAR_CHART'
  | 'CHANGE_LOADING'
  | 'CHANGE_CHART_RESPONSE'
  | 'SET_EXPRESSION_VARIABLES';

export const changeChart = (chart: Partial<Chart>) =>
  ({
    type: 'CHANGE_CHART',
    payload: chart,
  }) as ReduxBaseAction<Partial<Chart>, ChartActions>;
export const changeChartEditorOptions = (chartEditorOptions: ChartEditorOptions) =>
  ({
    type: 'CHANGE_CHART_EDITOR_OPTIONS',
    payload: chartEditorOptions,
  }) as ReduxBaseAction<ChartEditorOptions, ChartActions>;

export const changeChartResponse = (response: ChartJsDataModel | undefined) =>
  ({
    type: 'CHANGE_CHART_RESPONSE',
    payload: response,
  }) as ReduxBaseAction<ChartJsDataModel, ChartActions>;

export const changeIsUpdate = (isUpdate: boolean) =>
  ({
    type: 'CHANGE_IS_UPDATE',
    payload: isUpdate,
  }) as ReduxBaseAction<boolean, ChartActions>;

export const clearChart = () =>
  ({
    type: 'CLEAR_CHART',
    payload: void 0,
  }) as ReduxBaseAction<undefined, ChartActions>;

export const changeLoading = (loading: boolean) => ({
  type: 'CHANGE_LOADING',
  payload: loading,
});

export const setExpressionVariables = (variables: Record<string, TokenVariable[]>) =>
  ({
    type: 'SET_EXPRESSION_VARIABLES',
    payload: variables,
  }) as ReduxBaseAction<any, ChartActions>;
